<template>
    <div>
        <ul style="list-style-type:none;margin: 0;padding: 0px 0 15px 0px">
        <draggable v-model="vtags" class="dragarea" :options="{ handle: '.my-handle', filter: '.ignore-elements', animation: 150}" >
            <tag-item v-for="(tag,index) in vtags" :key="'tag_'+ index" class="item" v-model="vtags[index].text" @onDelete="removeTag(index)" @onChange="updateTag(index,$event)" @tags-changed="$emit('tags-changed',vtags)"></tag-item>
            
            <span slot="footer">
                <span v-if="max == 0 || max > vtags.length">
                    <a ref="addTagBtn" href="javascript:void(0);" v-if="!isAdd"  class="btn btn-primary btn-sm" @click="onClickAddBtn" ><i class="fas fa-plus"></i> Add</a>
                    <input v-else ref="addInput" type="text" style="padding: 5px 10px; border: 1px solid #eee;border-radius: 10px;" @blur="addNewTag" @keyup.enter="addNewTag" v-model="newTag" placeholder="Type Message">
                </span>
            </span>
        </draggable>
        </ul>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import TagItem from './TagItem'
    export default {
        props: {
            'value' : undefined,
            'tags': undefined,
            'edit' : {
                type: Boolean,
                default: false
            },
            'placeholder' : 'Type Message',
            'max' : {
                type: Number,
                default: 0
            }
        },
        components: {
            draggable,
            TagItem
        },
        data: function(){
            return {
                isAdd: false,
                vtags: [],
                newTag: ''
            }
        },
        mounted: function(){
            if (this.tags) {
                this.vtags = this.tags
            }
        },
        methods: {
            onClickAddBtn: function(){
                var vm  =this
                vm.isAdd = true
                vm.$nextTick(function(){
                    vm.$refs.addInput.focus()
                })
                
            },
            pressEnter: function(e){
                if (e.keyCode === 13) {
                    this.addNewTag()
                } 
            },
            addNewTag: function(){
                var vm = this
                if (vm.newTag.trim() == '') {
                    vm.newTag = ''
                    vm.isAdd = false
                    return false;
                }
                var tags = vm.newTag.split(',')
                var isDuplicate = false
                $.each(tags,function(index,tag){
                    if (tag.trim() != '') {
                        if (vm.vtags.map(t => t.text).indexOf(tag.trim()) !== -1 ) {
                            isDuplicate = true
                        } else {
                            isDuplicate = false
                        }
                        vm.$emit('before-adding-tag',Object.assign({},
                        {
                            tag: {
                                // status: 'add',
                                text: tag.trim(),
                                isDuplicate: isDuplicate
                            },
                            addTag: function (event) {
                                vm.vtags.push({text: tag})
                                vm.$emit('tags-changed',vm.vtags);
                                vm.$nextTick(function(){
                                    vm.$refs.addTagBtn.click()
                                })
                            },
                            error: function(){
                                vm.isError = true
                            }
                        }))
                    }
                })

                if (!isDuplicate) {
                    vm.newTag = ''
                    vm.isAdd = false
                }
            },
            removeTag: function(index){
                this.vtags.splice(index,1)
            },
            updateTag: function(index,payload){
                // console.log(payload)
                var vm  =this
                var isDuplicate = false
                // console.log(vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()),index)
                if (vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== index && 
                    vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== -1 ) {
                    isDuplicate = true
                } else {
                    isDuplicate = false
                }
                payload.tag.isDuplicate = isDuplicate
                vm.$emit('before-adding-tag',payload)
            }
        },
        watch: {
            vtags: function(){
                // console.log(this.vtags)
                this.$emit('tags-changed',this.vtags);
            },
            // tags: function(){
            //     this.vtags = this.tags
            // }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/elements/Tags.vue